import styled from 'styled-components';
import { spacing } from 'elemental-ui';

export const PageWrapper = styled.div`
  margin-left: ${spacing.xs};
  margin-right: ${spacing.xs};
  margin-top: ${spacing.l};
`;
